import React from "react";
import { MiniKitProvider as MKProvider } from "@coinbase/onchainkit/minikit";
import { base } from "viem/chains";

// MiniKitProvider component that wraps the app to enable MiniKit hooks
export function MiniKitProvider(props) {
  return (
    <MKProvider
      apiKey={process.env.REACT_APP_CDP_CLIENT_API_KEY}
      chain={base}
      config={{
        appearance: {
          mode: "auto",
          theme: "snake",
          name: process.env.REACT_APP_ONCHAINKIT_PROJECT_NAME,
          logo: process.env.REACT_APP_ICON_URL,
        },
      }}
    >
      {props.children}
    </MKProvider>
  );
} 